import { getDeviceInfo } from "helpers/utils";
import { getUserToken } from "../helpers/authHelper";
import api from "../api";


export async function FetchScheduledList() {

  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/schedule/scheduled-list`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "","X-lang_id": localStorage.getItem("lang_id") || "", },
  });
}
export async function RejectScheduleRecord(appl_id) {
  // console.log('faqsServices:24',appl_id);
 return await api({
   method: "put",
   data: '',
   url: `${process.env.REACT_APP_API_URL}/admin/common/reject-application/${appl_id}`,
   headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
 });
}


export async function updateselected(appl_id, formData) {
  return await api({
    method: "patch",
    url: `${process.env.REACT_APP_API_URL}/admin/schedule/update-selected/${appl_id}`,
    data: formData, 
    headers: { 
      Authorization: getUserToken(), 
      "X-DomainID": localStorage.getItem("subdomainId") || "", "X-lang_id": localStorage.getItem("lang_id") || "",
      'Content-Type': 'multipart/form-data' 
    },
  });
}

